import { CLIENT_CATEGORY } from "utils/constants";
import * as yup from "yup";

const validation = (messages, profile) => {

  const isParticular = profile === CLIENT_CATEGORY.PARTICULAR;
  const isTns = profile === CLIENT_CATEGORY.TNS;
  const isTerritorial = profile === CLIENT_CATEGORY.TERRITORIAL_AGENT;

  const isRequired = isParticular || isTns;

  return yup.object().shape({
    healthInsuranceRightsCertificate: yup
      .array()
      .of(
        yup.object().shape({
          name: yup.string().required(messages.REQUIRED),
        })
      )
      .required(messages.REQUIRED_ATTACHMENT)
      .min(1, messages.REQUIRED_ATTACHMENT)
      .max(1, messages.ONE_FILE),

    paymentAccount: yup
      .array()
      .of(
        yup.object().shape({
          name: yup.string().required(messages.REQUIRED),
        })
      )
      .required(messages.REQUIRED_ATTACHMENT)
      .min(1, messages.REQUIRED_ATTACHMENT)
      .max(1, messages.ONE_FILE),

    cin: yup
      .array()
      .of(
        yup.object().shape({
          name: yup.string().required(messages.REQUIRED),
        })
      )
      .required(messages.REQUIRED_ATTACHMENT)
      .min(1, messages.REQUIRED_ATTACHMENT)
      .max(2, messages.ONE_FILE),

    proofOfEligibility: isRequired
      ? yup
          .array()
          .of(
            yup.object().shape({
              name: yup.string().required(messages.REQUIRED),
            })
          )
          .required(messages.REQUIRED_ATTACHMENT)
          .min(1, messages.REQUIRED_ATTACHMENT)
          .max(1, messages.ONE_FILE)
      : yup.mixed().notRequired(),

  });
};

export default validation;
